var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.837 5.66363C12.2463 5.66363 13.3888 4.52115 13.3888 3.11182C13.3888 1.70249 12.2463 0.559998 10.837 0.559998C9.42764 0.559998 8.28516 1.70249 8.28516 3.11182C8.28516 4.52115 9.42764 5.66363 10.837 5.66363Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.837 13.44C12.2463 13.44 13.3888 12.2975 13.3888 10.8882C13.3888 9.47885 12.2463 8.33636 10.837 8.33636C9.42764 8.33636 8.28516 9.47885 8.28516 10.8882C8.28516 12.2975 9.42764 13.44 10.837 13.44Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14453 5.47909C1.2591 5.33779 1.38696 5.2078 1.52635 5.09091",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12587 4.70909C2.62569 4.48111 3.18585 4.42095 3.72269 4.5376C4.25952 4.65425 4.74421 4.94144 5.10435 5.35628C5.4645 5.77112 5.68077 6.29135 5.72086 6.83924C5.76095 7.38714 5.62272 7.9333 5.3268 8.39615C5.03088 8.859 4.59316 9.21369 4.07902 9.40724C3.56489 9.6008 3.00194 9.62282 2.47425 9.47004C1.94656 9.31725 1.48247 8.99784 1.15129 8.55953C0.820107 8.12122 0.639616 7.58753 0.636774 7.03818C0.634586 6.70886 0.697295 6.38234 0.82132 6.07727",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 5.86728L8.51605 4.27637",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47266 8.10727L8.56538 9.73636",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1621e992.svg";
export { ForwardRef as ReactComponent };